export enum DocumentType {
	CV = 'CV',
	TECHNICAL_REPORT = 'TECHNICAL_REPORT',
	DEVELOPER_CV = 'DEVELOPER_CV'
}
